import {
  __decorateClass
} from "./chunk.WHWUXFA2.js";

// src/components/jb-ref-teaser/jb-ref-teaser.ts
import "@bjb/bjb-web-components/dist/components/jb-picture/jb-picture";
import "@bjb/bjb-web-components/dist/components/jb-teaser-header/jb-teaser-header";
import "@bjb/bjb-web-components/dist/components/jb-thumbnail/jb-thumbnail";
import { jbLinkClickedEventToJbTrackingEvent, Linkable } from "@bjb/bjb-web-components/dist/mixins";
import { html, LitElement, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// src/components/jb-ref-teaser/jb-ref-teaser.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_ref_teaser_default = css`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* stylelint-disable */
/* stylelint-enable */
h3 {
  font-family: VerlagSSm, Tahoma, sans-serif;
  font-style: normal;
  font-weight: 300;
}

h3 {
  font-size: 22px;
  line-height: 28px;
}
@media (min-width: 1281px) {
  h3 {
    font-size: 26px;
    line-height: 36px;
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
  --teaser-header-h3-margin-bottom: 20px;
  --teaser-header-h3-margin-top: 20px;
}

article {
  margin-bottom: var(--article-card-bottom, 0);
  position: relative;
}
article.horizontal {
  display: flex;
  gap: 10px;
}
@media (min-width: 600px) {
  article.horizontal {
    gap: 16px;
  }
}
article.no-image {
  --teaser-header-h3-margin-top: 0;
  border: 1px solid rgba(20, 30, 85, 0.2);
  transition: border 0.7s ease-in-out 0s;
}
article.no-image:hover {
  border-color: #141e55;
}

.wrapper {
  position: relative;
}

.image-link {
  flex-basis: 25%;
  flex-shrink: 0;
}
@media (min-width: 960px) {
  .image-link {
    flex-basis: 33%;
  }
}

.horizontal .text-link {
  padding-bottom: 0;
}
.no-image .text-link {
  padding: 24px 24px 0;
}

.horizontal jb-ref-teaser-meta {
  position: static;
}
.no-image jb-ref-teaser-meta {
  display: flex;
  padding: 0 24px 24px;
}

a {
  display: block;
  text-decoration: none;
}
a figure {
  overflow: hidden;
}

h3 {
  padding-bottom: 16px;
}

@media print {
  :host {
    break-inside: avoid;
  }
}`;

// src/components/jb-ref-teaser/jb-ref-teaser.ts
var JbRefTeaser = class extends Linkable(LitElement) {
  constructor() {
    super(...arguments);
    this.direction = "vertical";
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "teaser"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    const classes = {
      horizontal: this.direction === "horizontal",
      "no-image": !this.teaserHeader.picture && !this.teaserHeader.thumbnail
    };
    return html`
      <article class="${classMap(classes)}">
        ${this.direction === "horizontal" ? html`
              <a
                class="image-link"
                data-linkable
                @jb-link:clicked=${this._tracking}
              >
                ${this.teaserHeader.picture ? html`
                      <jb-picture
                        .alt=${this.teaserHeader.picture.alt}
                        .fit=${"cover"}
                        .imgData=${this.teaserHeader.picture.imgData}
                        .lazy=${this.teaserHeader.picture.lazy}
                      ></jb-picture>
                    ` : nothing}
                ${this.teaserHeader.thumbnail ? html`
                      <jb-thumbnail
                        .backgroundPicture="${this.teaserHeader.thumbnail.backgroundPicture}"
                        .videoSrc="${this.teaserHeader.thumbnail.videoSrc}"
                        .aspect="${this.teaserHeader.thumbnail.aspect}"
                        .type="${this.teaserHeader.thumbnail.type}"
                      ></jb-thumbnail>
                    ` : nothing}
              </a>
            ` : nothing}
        <div class="wrapper">
          <a
            class="text-link"
            data-linkable
            @jb-link:clicked=${this._tracking}
          >
            ${this.direction !== "horizontal" ? html`
                  <jb-teaser-header
                    .headline=${this.teaserHeader.headline}
                    .picture=${this.teaserHeader.picture}
                    .teaser=${this.teaserHeader.teaser}
                    .thumbnail=${this.teaserHeader.thumbnail}
                    ?gallery=${this.gallery}
                  ></jb-teaser-header>
                ` : html` <h3>${this.teaserHeader.headline}</h3> `}
          </a>
          ${this.teaserMeta ? html` <jb-ref-teaser-meta
                .infos=${this.teaserMeta.infos}
                .tags=${this.teaserMeta.tags}
              ></jb-ref-teaser-meta>` : nothing}
        </div>
      </article>
    `;
  }
};
JbRefTeaser.styles = unsafeCSS(jb_ref_teaser_default);
__decorateClass([
  property()
], JbRefTeaser.prototype, "direction", 2);
__decorateClass([
  property({ type: Boolean })
], JbRefTeaser.prototype, "gallery", 2);
__decorateClass([
  property({ type: Object })
], JbRefTeaser.prototype, "teaserHeader", 2);
__decorateClass([
  property({ type: Object })
], JbRefTeaser.prototype, "teaserMeta", 2);
JbRefTeaser = __decorateClass([
  customElement("jb-ref-teaser")
], JbRefTeaser);

export {
  JbRefTeaser
};
